import { defineSlotRecipe } from '@chakra-ui/react';

export const dataTableSlotRecipe = defineSlotRecipe({
	slots: [ 'root', 'header', 'row', 'cell' ],

	base: {
		cell: {
			border:      '1px solid',
			borderColor: '#EAEAEA',
			p:           '24px',
		},
		header: {
			alignItems:     'center',
			bg:             'blue',
			color:          'white',
			display:        'flex',
			justifyContent: 'space-between',
			px:             '16px',
			py:             '8px',
			textStyle:      'h3',
		},
		root: {
			border:      '1px solid',
			borderColor: '#EAEAEA',
		},
	},
});
